import { useTranslation } from 'react-i18next'
import {
  SearchAutocomplete,
  SearchAutocompleteOption,
} from '@/components/inputs'

export type AttentionTaskStatusSelectProps = {
  value?: string
  onChange: (value: string | undefined) => void
}

const ATTENTION_TASK_STATUSES: string[] = [
  'todo',
  'completed',
  'accepted',
  'rework',
]

export const AttentionTaskStatusSelect = ({
  value,
  onChange,
}: AttentionTaskStatusSelectProps): JSX.Element => {
  const { t } = useTranslation('forms')

  const options: SearchAutocompleteOption[] = ATTENTION_TASK_STATUSES.map(
    (status) => ({
      label: t(`attentionTaskStatus.${status}`),
      value: status,
    })
  )

  return (
    <SearchAutocomplete
      value={value}
      onChange={onChange}
      options={options}
      placeholder={t('placeholders.taskStatus')}
      sort={false}
      fieldSx={{ width: 280 }}
    />
  )
}
